import React from 'react';
import Currency from 'react-currency-formatter';

export default function DiscountCurrency({ quantity, currency, discount }) {
	if(discount > 0) {
		return <span>
			<del className="font-weight-lighter"><Currency quantity={quantity} currency={currency} /></del>
			{' - '}
			<strong><Currency quantity={quantity * (1 - (discount ?? 0))} currency={currency} /></strong>
		</span>;
	}
	return <Currency quantity={quantity} currency={currency} />;
}
